import { imgSrcSet, imgUrl } from "@/lib/api";

// With a focal point: fills the slot (object-cover) keeping that point in view.
// Without one: shows the whole image (object-contain) with a blurred fill behind.
// Serves responsive WebP variants and lazy-loads unless `priority` is set.
export const FitImage = ({
  src, alt = "", focalX = null, focalY = null, className = "relative", imgClassName = "",
  sizes = "100vw", priority = false, ...rest
}) => {
  const hasFocal = focalX != null && focalY != null;
  const srcSet = imgSrcSet(src);
  const common = {
    src: imgUrl(src, 960),
    srcSet,
    sizes,
    decoding: "async",
    loading: priority ? "eager" : "lazy",
    fetchPriority: priority ? "high" : "auto",
  };
  if (hasFocal) {
    return (
      <div className={`w-full h-full overflow-hidden ${className}`}>
        <img {...common} alt={alt} className={`w-full h-full object-cover ${imgClassName}`}
          style={{ objectPosition: `${focalX}% ${focalY}%` }} {...rest} />
      </div>
    );
  }
  return (
    <div className={`w-full h-full overflow-hidden ${className}`}>
      <img src={imgUrl(src, 320)} alt="" aria-hidden="true" loading={common.loading} decoding="async"
        className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-80" />
      <img {...common} alt={alt} className={`relative w-full h-full object-contain ${imgClassName}`} {...rest} />
    </div>
  );
};
